export const DEFAULT_PLAYER_ROLE = 'player'

export function normalizePlayers(playersData) {
  if (!playersData) {
    return {}
  }

  if (Array.isArray(playersData)) {
    return playersData.reduce((acc, entry) => {
      if (typeof entry === 'string') {
        acc[entry] = {
          role: DEFAULT_PLAYER_ROLE,
          joinedAt: null
        }
      } else if (entry && typeof entry === 'object') {
        const id = entry.id || entry.uid || entry.userId
        if (id) {
          acc[id] = {
            role: entry.role || DEFAULT_PLAYER_ROLE,
            joinedAt: entry.joinedAt || null
          }
        }
      }
      return acc
    }, {})
  }

  if (typeof playersData === 'object') {
    return Object.entries(playersData).reduce((acc, [id, value]) => {
      if (!id) {
        return acc
      }

      acc[id] = {
        role: value?.role || DEFAULT_PLAYER_ROLE,
        joinedAt: value?.joinedAt || null
      }

      return acc
    }, {})
  }

  return {}
}

export function getPlayerIds(playersData) {
  return Object.keys(normalizePlayers(playersData))
}

export function getPlayerCount(playersData) {
  return getPlayerIds(playersData).length
}

export function hasPlayer(playersData, userId) {
  if (!userId) {
    return false
  }

  const normalized = normalizePlayers(playersData)
  return Boolean(normalized[userId])
}

export function getPlayerRole(playersData, userId) {
  if (!userId) {
    return null
  }

  const normalized = normalizePlayers(playersData)
  return normalized[userId]?.role || null
}
